import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Search from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, DialogContentText, FormControl, InputLabel } from '@material-ui/core';
import AcertoCoparticipacaoService from '../../services/AcertoCoparticipacaoService';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import { inject, observer } from 'mobx-react';
import Slider from '@material-ui/lab/Slider';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  paperFiltro: {
    height: 150,
    maxHeight: 150
  },
  fontTable: {
    fontSize: 12
  },
  fontTableRed: {
    fontSize: 13,
    color: 'red',
  },
  fontTableBlue: {
    fontSize: 13,
    color: 'blue',
  },
  typography: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    fontSize: 16,
    textAlign: 'center'
  },
  formControlAutoCompleteGuia: {
    margin: theme.spacing.unit,
    minWidth: 350,
  },
  formControlAutoCompleteDemonstrativo: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  formControlAutoCompletePrestador: {
    margin: theme.spacing.unit,
    minWidth: 450,
  },
  calcPerc: {
    marginLeft: theme.spacing.unit * 7,
    display: 'inline-flex',
  },
  slider: {
    width: 250,
    display: 'flex',
    marginLeft: theme.spacing.unit * 1,
    paddingTop: theme.spacing.unit * 1.5,
  },
  typographySlider: {
    marginLeft: theme.spacing.unit * 4,
  },
  typographyText: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 1.5,
    color: theme.palette.text.secondary,
  },
  typographyInfo: {
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
});

@inject('aplicacaoStore')
@observer

class FormDialogProcedimentosCopartCalcIncorreto extends React.Component {
  acertosService = new AcertoCoparticipacaoService();
  state = {
    guias: [],
    demonstrativos: [],
    prestadores: [],
    procedimentos: [],
    rowsSelected: [],
    codGuiaSelected: 0,
    numDemonstrativoSelected: 0,
    seqPrestadorSelected: 0,
    fetching: false,
    valAcerto: 0,
    percentualSelected: 0,
    percentualInicial: 0,
    indCobrarDevolver: '',
    info: '*Valores positivos serão cobrados do beneficiário. Os negativos serão devolvidos.',
  }
  componentDidMount = async () => {
    await this.consultarPrestadores();
    await this.consultarGuias();
    await this.consultarDemonstrativos();
  }
  consultarPrestadores = async () => {
    let prestadores = await this.props.aplicacaoStore.getPrestadoresCredenciados();
    this.setState({ prestadores: prestadores });
  }
  consultarGuias = async () => {
    let guias = await this.acertosService.consultarGuias(this.props.numMatricula);
    this.setState({ guias: guias });
  }
  consultarDemonstrativos = async () => {
    let demonstrativos = await this.acertosService.consultarDemonstrativos(this.props.numMatricula);
    this.setState({ demonstrativos: demonstrativos });
  }
  consultarProcedimentos = async (filtro) => {
    this.setState({fetching: true});
    let seqProcedimentosSelecionados = [];
    for (var i = 0; i < this.props.procsSelecionados.length; i++) {
      seqProcedimentosSelecionados.push(this.props.procsSelecionados[i][0]);
    }
    let procedimentos = await this.acertosService.consultarProcedimentosCopartCalcIncorreto(this.props.numMatricula, filtro.codGuia, filtro.numDemonstrativo, filtro.seqPrestador, seqProcedimentosSelecionados);
    this.setState({procedimentos: procedimentos, fetching: false, percentualSelected: 0});
  }
  handleClickBuscar = async () => {
    this.setState({procedimentos: []});
    const filtro = {
      codGuia: this.state.codGuiaSelected === undefined || this.state.codGuiaSelected === '' ? 0 : this.state.codGuiaSelected,
      numDemonstrativo: this.state.numDemonstrativoSelected === undefined || this.state.numDemonstrativoSelected === '' ? 0 : this.state.numDemonstrativoSelected,
      seqPrestador: this.state.seqPrestadorSelected === undefined || this.state.seqPrestadorSelected === '' ? 0 : this.state.seqPrestadorSelected,
    };
    await this.consultarProcedimentos(filtro);
    this.setState({percentualSelected: this.state.procedimentos[0][13], percentualInicial: this.state.procedimentos[0][13]});
    await this.escolherPercentual();
  }
  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    let procedimentosSelecionados = [];
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      procedimentosSelecionados.push(this.state.procedimentos[this.state.rowsSelected[i]]);
    }
    this.props.handleSave(procedimentosSelecionados, this.state.valAcerto, this.state.indCobrarDevolver, this.state.percentualSelected);
  }
  getSuggestionValueGuia = (suggestion, id) => {
    this.setState({
      codGuiaSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  getSuggestionValueDemonstrativo = (suggestion, id) => {
    this.setState({
      numDemonstrativoSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  getSuggestionValuePrestador = (suggestion, id) => {
    this.setState({
      seqPrestadorSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  // handleChangeRadio = event => {
  //   this.setState({ fetching: true });
  //   let procedimentos = this.state.procedimentos;
  //   for (var i = 0; i < procedimentos.length; i++) {
  //     procedimentos[i][18] = 0;
  //   }
  //   let info = '';
  //   if (event.target.value === 'COBRAR') {
  //     info = '* A coluna "Novo Valor" corresponde ao percentual escolhido x o valor do procedimento. O valor do ajuste a ser cobrado do beneficiário é a diferença entre o valor efetivamente cobrado e o novo valor.';
  //   } else {
  //     info = '* A coluna "Novo Valor" corresponde ao percentual escolhido x o valor efetivamente cobarado. O valor do ajuste é a diferença entre o valor efetivamente cobrado e o novo valor.';
  //   }
  //   this.setState({ valueRadio: event.target.value,
  //     fetching: false,
  //     procedimentos: procedimentos,
  //     percentualSelected: 0,
  //     info: info });
  // };
  handleChangeRange = (event, value) => {
    this.setState({ percentualSelected: value });
  };
  handleEscolherPercentual = async event => {
    await this.escolherPercentual();
  };
  escolherPercentual = async () => {
    this.setState({ fetching: true });
    const percEscolhido = this.state.percentualSelected;
    let indCobrarDevolver = 'DEVOLVER';
    let procedimentos = this.state.procedimentos;
    for (var i = 0; i < procedimentos.length; i++) {
      procedimentos[i][18] = procedimentos[i][14] * percEscolhido / 100;
      procedimentos[i][19] = Number((procedimentos[i][14] * percEscolhido / 100) - procedimentos[i][15]).toFixed(2);
      if (percEscolhido < procedimentos[i][13]) {
        indCobrarDevolver = 'COBRAR';
      }
      if (percEscolhido === procedimentos[i][13]) {
        indCobrarDevolver = '';
      }
    }
    this.setState({ fetching: false, procedimentos: procedimentos, indCobrarDevolver: indCobrarDevolver });
  }
  render () {
    const options = {
      print: true,
      download: true,
      selectableRows: this.state.procedimentos.length !== 0 && this.state.percentualInicial !== this.state.percentualSelected,
      rowsSelected: this.state.rowsSelected,
      valAcerto: this.state.valAcerto,
      onRowsSelect: (rowsSelected, allRows) => {
        const selected = allRows.map(item => item.index);
        let valAcertoAux = 0;
        for (var i = 0; i < allRows.length; i++) {
          valAcertoAux = valAcertoAux + Number(this.state.procedimentos[allRows[i].index][19]);
        }
        this.setState({rowsSelected: selected, valAcerto: valAcertoAux});
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>procedimento(s) selecionado(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'Cod. Cobrança',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Carteira',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Tabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Guia',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Data do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Está na franquia?',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Percentual Cobrado',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value + '%'}</Typography>;
          },
        }
      },
      {
        name: 'Valor do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Calculado de Copart.',
        options: {
          display: 'excluded',
          filter: false,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Efetivamente Cobrado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'seqDivida',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Valor que Deveria Ter Sido Cobrado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor do Ajuste',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return this.state.indCobrarDevolver === 'COBRAR'
              ? <Typography className={classes.fontTableRed}>{nf.format(value)}</Typography>
              : this.state.indCobrarDevolver === 'DEVOLVER'
                ? <Typography className={classes.fontTableBlue}>{nf.format(value)}</Typography>
                : <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },
      {
        name: 'brancoAcoes',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const { open, titulo, nome, numMatricula, classes } = this.props;
    const { procedimentos, fetching, prestadores, info,
      guias, /* demonstrativos, */ percentualSelected } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='lg'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle>{titulo + ' - '}
            Valor Total: {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valAcerto)}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {'Preencha os filtros para encontrar os procedimentos calculados incorretamente de '} {numMatricula} {' '} {nome}
            </DialogContentText>
            <Paper className={classes.paperFiltro} elevation={1}>
              <FormControl className={classes.formControlAutoCompleteGuia}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueGuia}
                  suggestions={guias}
                  maxSuggestions={3}
                  placeholder={'Digite a Guia...'} />
              </FormControl>
              {/* <FormControl className={classes.formControlAutoCompleteDemonstrativo}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueDemonstrativo}
                  suggestions={demonstrativos}
                  maxSuggestions={3}
                  placeholder={'Digite o Demonstrativo...'} />
                </FormControl> */}
              <FormControl className={classes.formControlAutoCompletePrestador}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValuePrestador}
                  suggestions={prestadores}
                  maxSuggestions={3}
                  placeholder={'Digite o nome do prestador...'} />
              </FormControl>
              <FormControl>
                <Button
                  variant='extendedFab'
                  disabled={this.state.codGuiaSelected === 0 && this.state.seqPrestadorSelected === 0}
                  title='Buscar'
                  type='submit'
                  onClick={this.handleClickBuscar}
                  onTouchStart={this.handleClickBuscar}
                  className={classes.button}>
                  <Search className={classes.searchIcon} />
                  Buscar
                </Button>
              </FormControl>
              <div className={classes.calcPerc}>
                <Typography className={classes.typographyText}>Percentual que deveria ter sido cobrado:</Typography>
                {/* <FormControlLabel
                  label='Cobrar Copart.'
                  control={<Radio
                    disabled={procedimentos.length === 0}
                    checked={this.state.valueRadio === 'COBRAR'}
                    aria-label='Cobrar Coparticipação'
                    onChange={this.handleChangeRadio}
                    value='COBRAR'
                    name='radio-COBRAR' />}
                />
                <FormControlLabel
                  label='Devolver Copart.'
                  control={<Radio
                    disabled={procedimentos.length === 0}
                    checked={this.state.valueRadio === 'DEVOLVER'}
                    aria-label='Devolver Coparticipação'
                    onChange={this.handleChangeRadio}
                    value='DEVOLVER'
                    name='radio-DEVOLVER' />}
                /> */}
                <div className={classes.slider}>
                  <Typography
                    disabled={procedimentos.length === 0}>
                    {percentualSelected.toString().concat('%')}
                  </Typography>
                  <InputLabel shrink className={classes.typographySlider}>0</InputLabel>
                  <Slider
                    disabled={procedimentos.length === 0}
                    value={percentualSelected}
                    step={1}
                    onChange={this.handleChangeRange}
                    onDragEnd={this.handleEscolherPercentual}
                  />
                  <InputLabel shrink>100</InputLabel>
                </div>
              </div>
              { procedimentos.length !== 0
                ? <Typography className={classes.typographyInfo}>{info}</Typography>
                : null
              }
            </Paper>
            {fetching ? <LinearProgressBlockScreen />
              : <Paper>
                <MUIDataTable
                  data={procedimentos}
                  columns={columns}
                  options={options}
                />
              </Paper>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.rowsSelected.length === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogProcedimentosCopartCalcIncorreto);
